import { FormValues } from './types';

type FormValuesValidate = Record<string, string>;

export const UserSettingsValidator = (values: FormValues): FormValuesValidate => {
  const errors: FormValuesValidate = {};

  if (values.user_groups.includes(0)) {
    errors.user_groups = 'app.validation.required';
  }

  return errors;
};
